<template>
    <ModalInput
        v-model:open="showModal"
        v-model:text="inputData"
        :modal-data="modalInputData"
        @cta="$emit('updateUuid')"
        @cancel="showModal = false"
        size="lg"
    >
        <template #icon>
            <CardIcon type="success">
                <LinkChainIcon />
            </CardIcon>
        </template>
        <div class="space-y-1">
            <p>{{ $t("shared.change_url.list") }}</p>
            <ul class="list-disc list-inside">
                <li v-for="(link, index) in links" :key="index" class="break-all">
                    {{ link.title }} -
                    <a :href="link.url" target="_blank" class="underline" v-html="link.url"></a>
                </li>
            </ul>
            <p>{{ $t("shared.change_url.info") }}</p>
        </div>
    </ModalInput>
</template>
<script>
import { ModalInput } from "@easy/ui/modals";
import { CardIcon } from "@easy/ui/cards";
import { LinkChainIcon } from "@easy/ui/icons";
import { slugify } from "@/shared/utils/helpers";

export default {
    components: {
        ModalInput,
        CardIcon,
        LinkChainIcon,
    },
    emits: ["update:open", "update:slug", "updateUuid"],
    props: {
        open: Boolean,
        slug: { type: String, default: "" },
        links: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        showModal: {
            get() {
                return this.open;
            },
            set(value) {
                this.$emit("update:open", value);
            },
        },
        inputData: {
            get() {
                return this.slug;
            },
            set(value) {
                this.$emit("update:slug", slugify(value));
            },
        },
        modalInputData() {
            return {
                title: this.$t("shared.change_url.address"),
                inputLabel: this.$t("shared.change_url.label"),
                ctaLabel: this.$t("shared.change"),
                cancelLabel: this.$t("shared.cancel"),
            };
        },
    },
};
</script>
